import EnMessages from '@/i18n/locales/en.json'
import PtMessages from '@/i18n/locales/pt.json'
import store from '@/store'
import { createI18n } from 'vue-i18n'

const __DEFAULT__LOCALE__ = 'en'

const i18n = createI18n({
	locale: store.state.App.locale,
	fallbackLocale: __DEFAULT__LOCALE__,
	messages: {
		en: EnMessages,
		pt: PtMessages,
	},
})

export default i18n
